import { render, staticRenderFns } from "./RelateForMainTask.vue?vue&type=template&id=30f94510&scoped=true&"
import script from "./RelateForMainTask.vue?vue&type=script&lang=js&"
export * from "./RelateForMainTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f94510",
  null
  
)

export default component.exports